export default __webpack_public_path__ + "static/media/african-proficient-group-image.d9b9f590.jpg";